import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type SpecificationsClasses = 'container' | 'title' | 'description';

const specificationsStyles = makeStyles<ISpcTheme, SpecificationsClasses>(
  theme => ({
    container: {
      paddingBottom: 20,
    },
    title: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: theme.typography.fontMD,
      paddingBottom: 5,
    },
    description: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.fontSM,
    },
  }),
  { name: 'Customise_Specifications' },
);

export default specificationsStyles;
